'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024188 from "./presto.types$$anon$188.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$187() {
  this.ceX = null;
  this.ceV = null;
  this.ceW = false;
  this.ceT = null;
  this.ceU = false;
  this.ceY = false;
  this.ceZ = false;
  this.ceX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$187 as $c_Lpresto_types$proto$$anon$187 };
$p = $c_Lpresto_types$proto$$anon$187.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$187;
/** @constructor */
function $h_Lpresto_types$proto$$anon$187() {
}
export { $h_Lpresto_types$proto$$anon$187 as $h_Lpresto_types$proto$$anon$187 };
$h_Lpresto_types$proto$$anon$187.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.ceX;
});
$p.t = (function() {
  if ((!this.ceW)) {
    this.ceV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ranges", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ceW = true;
  }
  return this.ceV;
});
$p.ae = (function() {
  if ((!this.ceU)) {
    this.ceT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().a2G(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002etypes$0024$0024anon$0024188.$c_Lpresto_types$$anon$188()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ceU = true;
  }
  return this.ceT;
});
$p.w = (function() {
  if ((!this.ceZ)) {
    this.ceY = false;
    this.ceZ = true;
  }
  return this.ceY;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$187 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$187, "presto.types$proto$$anon$187", ({
  a2W: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$187 as $d_Lpresto_types$proto$$anon$187 };
//# sourceMappingURL=presto.types$proto$$anon$187.js.map
